import { SUPPORTED_LANGUAGES } from '../constants';

/**
 * Определяет язык браузера пользователя на основе системных настроек
 * Использует navigator.languages (приоритет) и navigator.language (fallback)
 * @returns Код языка из списка поддерживаемых языков или 'en' по умолчанию
 */
export const detectBrowserLanguage = (): string => {
  const supportedCodes = SUPPORTED_LANGUAGES.map((lang) => lang.code);

  // Приоритет 1: navigator.languages - список языков в порядке предпочтения
  if (navigator.languages && navigator.languages.length > 0) {
    for (const lang of navigator.languages) {
      const fullCode = lang.toLowerCase();
      const baseCode = fullCode.split('-')[0];

      // Проверяем полный код (например, 'pt-BR', 'ru-RU')
      if (supportedCodes.includes(fullCode)) {
        return fullCode;
      }

      // Специальная обработка для португальского (pt -> pt-BR)
      if (baseCode === 'pt') {
        return 'pt-BR';
      }

      // Проверяем базовый код для остальных языков
      if (supportedCodes.includes(baseCode)) {
        return baseCode;
      }
    }
  }

  // Приоритет 2: navigator.language - основной язык браузера
  if (navigator.language) {
    const fullCode = navigator.language.toLowerCase();
    const baseCode = fullCode.split('-')[0];

    // Проверяем полный код
    if (supportedCodes.includes(fullCode)) {
      return fullCode;
    }

    // Специальная обработка для португальского (pt -> pt-BR)
    if (baseCode === 'pt') {
      return 'pt-BR';
    }

    // Проверяем базовый код
    if (supportedCodes.includes(baseCode)) {
      return baseCode;
    }
  }

  // Приоритет 3: navigator.userLanguage (для старых версий IE)
  if ((navigator as { userLanguage?: string }).userLanguage) {
    const userLang = (navigator as { userLanguage?: string }).userLanguage?.toLowerCase();
    if (userLang) {
      const baseCode = userLang.split('-')[0];
      // Специальная обработка для португальского (pt -> pt-BR)
      if (baseCode === 'pt') {
        return 'pt-BR';
      }
      if (supportedCodes.includes(baseCode)) {
        return baseCode;
      }
    }
  }

  // Fallback: английский по умолчанию
  // Если язык не найден в списке поддерживаемых, возвращаем 'en'
  return 'en';
};
